import { subDays } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export default function EmailRecordsApi({ makeRequest, buildRequest, baseUrl = '' }) {
    const timeZone = 'Pacific/Auckland';

    function getEmailRecords(from = formatInTimeZone(subDays(new Date(), 6), timeZone, 'yyyy-MM-dd'), to = formatInTimeZone(new Date(), timeZone, 'yyyy-MM-dd')) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/EmailRecords/${from}/${to}`));
        });
    }

        function getPdf(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/EmailRecords/Document/${id}`, { responseType: 'blob' }));
        });
    }

    function putGrandTotal(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/EmailRecords/GrandTotal`, payload));
        });
    }

    function resetAll(){
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/EmailRecords/ResetAll`));
        });
    }

    return {
        getEmailRecords,
        getPdf,
        putGrandTotal,
        resetAll
    }
}